import { put, takeLatest } from 'redux-saga/effects';
import { Space, SpaceAPI } from 'api/space/space';
import { FetchStatus, StoreActionProps } from 'data/core';
import { saveSpaceTabs, addSpaceTab } from 'data/space-tabs';
import { fetchSpaceDetailSagaAction } from '../actions';
import {
  fetchDetailStart,
  fetchDetailSuccess,
  fetchDetailFailure,
} from '../index';

function* fetchSpaceDetailSaga(action: StoreActionProps<number>) {
  const { payload } = action;

  try {
    yield put(fetchDetailStart(payload));
    const data = (yield SpaceAPI.getSpaceDetail(payload)) as Space;

    if (data.spaceTabs.length > 0) {
      yield put(
        saveSpaceTabs({
          data: data.spaceTabs,
          fetchStatus: FetchStatus.Partial,
        }),
      );
    } else {
      /* Show empty tab */
      yield put(
        addSpaceTab({ spaceTabId: 'new', space: { spaceId: payload } }),
      );
    }

    yield put(fetchDetailSuccess(data));
  } catch (error) {
    yield put(fetchDetailFailure());
  }
}

export function* watchFetchSpaceDetailSaga(): Generator {
  yield takeLatest(fetchSpaceDetailSagaAction.type, fetchSpaceDetailSaga);
}
